"use client";

import { memo } from "react";
import Image from "next/image";
import Link from "next/link";
import { Award, Briefcase, FileText, LifeBuoy } from "lucide-react";

type AboutProps = {
  portfolio: any;
};

const About = ({ portfolio }: AboutProps) => {
  if (!portfolio) {
    return (
      <section className="py-20 text-center">
        <p>Portfolio not found.</p>
      </section>
    );
  }

  return (
    <section id="about" className="bg-[#fafafa] py-12">
      <header className="text-center space-y-2">
        <h2 className="text-4xl font-bold">About Me</h2>
        <p className="text-gray-600">My introduction</p>
      </header>

      <div className="mt-10 flex flex-wrap justify-center gap-12 px-4">
        {/* Image */}
        <figure className="w-72 h-72 relative">
          <Image
            src={portfolio.image}
            alt={`${portfolio.name} portrait`}
            fill
            className="object-cover rounded-3xl border-4 border-black shadow-lg"
            sizes="288px"
            // width={288}
            // height={288}
            loading="lazy"
          />
        </figure>

        {/* Content */}
        <article className="max-w-xl space-y-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <StatCard
              icon={<Award size={24} />}
              title="Experience"
              value={`${portfolio.years_experience}+ Years`}
            />
            <StatCard
              icon={<Briefcase size={24} />}
              title="Projects"
              value={`${portfolio.projects}+ Completed`}
            />
            <StatCard
              icon={<LifeBuoy size={24} />}
              title="Support"
              value="24/7 Online"
            />
          </div>

          <p className="text-gray-600 leading-relaxed">{portfolio.about}</p>

          {portfolio.cv && (
            <Link
              href={portfolio.cv}
              target="_blank"
              download
              className="inline-flex items-center gap-2 bg-black text-white px-6 py-3 rounded-xl hover:scale-105 transition"
            >
              Download CV <FileText size={20} />
            </Link>
          )}
        </article>
      </div>
    </section>
  );
};

const StatCard = ({ icon, title, value }: any) => (
  <div className="bg-white border border-gray-300 p-5 rounded-2xl shadow hover:shadow-xl transition text-center space-y-1">
    <div className="flex justify-center">{icon}</div>
    <h3 className="font-semibold">{title}</h3>
    <p className="text-sm text-gray-600">{value}</p>
  </div>
);

export default memo(About);
